import React from "react";
import svg43 from "../../../../../../assets/svg/svg43.svg";
import { Progress } from "antd";
import { useSelector } from "react-redux";
import { cashConverter } from "../../../../../../utils";
function ProjectCard() {
  const urlSingle = "api/v2/main_projects/get";
  const { loading, activeObjOngoingProject, dataProjSingle } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
      dataProjSingle: state.fetch.data[urlSingle] || [],
    })
  );

  const items = [
    {
      title: "Contract Sum",
      amount: dataProjSingle?.[0]?.projectCost,
    },
    {
      title: "Total IPC Value",
      amount: dataProjSingle?.[0]?.projectTotalDisbursement,
      progress: dataProjSingle?.[0]?.projectDisbursementPercentage,
    },
    {
      title: "Balance",
      amount:
        dataProjSingle?.[0]?.projectCost -
        dataProjSingle?.[0]?.projectTotalDisbursement,
    },
    {
      title: "Retained Amount",
      amount: dataProjSingle?.[0]?.projectTotalRetainedAmount,
    },
    {
      // From the project form's "Is there contingency?"; 0 when No or not set.
      title: "Contingency",
      amount:
        dataProjSingle?.[0]?.projectHasContingency === "Yes"
          ? dataProjSingle?.[0]?.projectContingencyAmount ?? 0
          : 0,
    },
  ];

  return (
    <div className="flex flex-shrink flex-wrap  gap-y-[1rem] gap-x-[1rem] mt-[1rem]">
      {items &&
        items?.map((item) => (
          <div className="rounded-[.5rem] border cursor-pointer border-[#D6E1F5] px-[.625rem] py-[1rem] h-auto bg-[#F7F7F7] w-auto lg:min-w-[190px]">
            <div className="flex items-center justify-between">
              <div
                className={`flex flex-col ${item?.progress ? "" : "w-full"}`}
              >
                <div className="flex  items-center justify-between">
                  <span className="font-interSans text-[.75rem] font-[500] text-[#0092CC]">
                    {item?.title}
                  </span>
                  <img src={svg43} alt="svg43" />
                </div>
                <div className="form-add-h lg:text-inherit !text-[18px] !text-[#050505] mt-[1.44rem]">
                  {cashConverter(item?.amount)}
                </div>
              </div>

              {item?.progress && (
                <div className="flex items-center flex-shrink-0">
                  <Progress
                    className={`object-contain w-[60px] h-[60px] ${
                      Number(item?.progress)?.toFixed(2) >
                      dataProjSingle?.[0]?.projectCompletionRate
                        ? "blink-red"
                        : ""
                    }`}
                    type="circle"
                    percent={Number(item?.progress)?.toFixed(2)}
                    strokeColor={
                      Number(item?.progress)?.toFixed(2) >
                      dataProjSingle?.[0]?.projectCompletionRate
                        ? "#B81B0E"
                        : "#4FAD5B"
                    }
                    format={(percent) => (
                      <span
                        style={{
                          color:
                            percent > dataProjSingle?.[0]?.projectCompletionRate
                              ? "#B81B0E"
                              : "#4FAD5B",
                        }}
                      >
                        {percent}%
                      </span>
                    )}
                    width={60}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
    </div>
  );
}

export default ProjectCard;
